import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when there is a response with geopacket from within the Geofencing process.
 * @memberOf Playtech.API.events
 * @event geofencing-response
 * @type {callback}
 * @param {object} detials
 * @param {number} details.time - time in milliseconds of how long it took to complete the trigger.
 * @param {number} details.transactionID - transaction ID as defined by IMS.
 * @example Playtech.on('geofencing-response', ({ time, transactionID }) => { ... });
 */
export const GEOFENCING_RESPONSE = 'geofencing-response';

export const useOnGeofencingResponse = (eventTarget: EventTarget): void => {
    const triggerGeofencingResponseEvent = useCallback((detail: {
        time: number;
        transactionCode: number | string;
    }) => {
        const event = new CustomEvent(GEOFENCING_RESPONSE, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('geofencing-response', triggerGeofencingResponseEvent);

        return () => {
            publicEventsAPIService.off('geofencing-response', triggerGeofencingResponseEvent);
        };
    }, [triggerGeofencingResponseEvent]);
};
